import { useState } from 'react'

import { CheckOutlined, CloseOutlined, CopyOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'

import { TIMEOUT_IN_MS } from './lib/constants'
import { type CopyStatus } from './lib/types'

interface CopyButtonProps extends React.ComponentProps<typeof Button> {
  getText: () => string | null | Promise<string | null>
}

export function CopyButton({ getText, ...props }: CopyButtonProps) {
  const [copyStatus, setCopyStatus] = useState<CopyStatus>('idle')

  const handleCopy = async () => {
    try {
      const text = await getText()
      if (!text) return

      await navigator.clipboard.writeText(text)

      setCopyStatus('success')
      setTimeout(() => setCopyStatus('idle'), TIMEOUT_IN_MS)
    } catch {
      setCopyStatus('error')
      setTimeout(() => setCopyStatus('idle'), TIMEOUT_IN_MS)
    }
  }

  const requestHandleCopy = () => {
    void handleCopy()
  }

  const renderIcon = () => {
    switch (copyStatus) {
      case 'success':
        return <CheckOutlined />
      case 'error':
        return <CloseOutlined />
      default:
        return <CopyOutlined />
    }
  }

  const renderTooltipTitle = () => {
    switch (copyStatus) {
      case 'success':
        return 'Скопировано'
      case 'error':
        return 'Не удалось скопировать'
      default:
        return 'Скопировать'
    }
  }

  return (
    <Tooltip title={renderTooltipTitle}>
      <Button {...props} icon={renderIcon()} onClick={requestHandleCopy} />
    </Tooltip>
  )
}
